import { render, staticRenderFns } from "./pension-report.vue?vue&type=template&id=7eb406dd"
import script from "./pension-report.vue?vue&type=script&lang=js"
export * from "./pension-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports